import { FC, useEffect } from "react";
import { UserProps } from "../../types";
import { Column, Row } from "../../../../../components/containers";
import { PopupClose, QuestionBox } from "../../../../../popup";
import { Heading, Text } from "../../../../../components/typography";
import {
  useAlertStore,
  usePopupStore,
  useThemeStore,
  useUserStore,
} from "../../../../../stores";
import {
  AlignItems,
  JustifyContent,
} from "../../../../../components/containers/types";
import AccessList from "../access-list";
import { Button } from "../../../../../components/buttons";
import { IconAnimation } from "../../../../../components/animation";
import { InfoIcon } from "../../../../../assets/icons";
import UserUpdatesPopup from "../user-updates-popup";
import UserEditPopup from "../user-edit-popup";
import styles from "../styles";
import { HOST_USER_FILES } from "../../../../../api/settings";
import UserSelfEditPopup from "../user-self-edit-popup";
import { UserApi } from "../../../../../api";

const UserProfilePopup: FC<UserProps> = (props) => {
  const user = useUserStore((s) => s.user);
  const { access_list, fullname, pic, role } = props;

  const theme = useThemeStore((state) => state.theme);
  const setPopupBody = usePopupStore((state) => state.setPopupBody);
  const setPopupProperties = usePopupStore((state) => state.setPopupProperties);
  const pushAlert = useAlertStore((s) => s.pushAlert);

  const onShowInfo = (): void => {
    setPopupBody(<UserUpdatesPopup {...props} />);
  };

  const onEditUser = (): void => {
    if (user?.username !== props.username) {
      setPopupBody(<UserEditPopup {...props} />);
    } else {
      setPopupBody(<UserSelfEditPopup />);
    }
  };

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 430,
        background: theme.background,
        height: "100%",
        maxHeight: 605,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDelete = (): void => {
    setPopupBody(
      <QuestionBox
        question={`آیا مطمئن هستید که می خواهید ${fullname} را حذف کنید؟`}
        close={false}
        back={{ component: UserProfilePopup, props }}
        onNo={() => {
          setPopupBody(<UserProfilePopup {...props} />);
        }}
        onYes={() => {
          UserApi.deleteUser(props._id.$oid)
            .then(() => {
              pushAlert("عملیات موفقیت آمیز");
              setPopupBody(null);
            })
            .catch((err) => {
              pushAlert(err.msg || "unknown error", "error");
            });
        }}
      />
    );
  };

  return (
    <Column
      style={styles.userPopupBase}
      justifyContent={JustifyContent.Between}
    >
      <PopupClose />
      <Row
        style={{ width: "calc(100% - 4rem)", margin: "1rem 2rem" }}
        justifyContent={JustifyContent.Between}
      >
        <img
          src={
            pic.substring(0, 4) === "data" ? pic : `${HOST_USER_FILES}/${pic}`
          }
          alt="profile"
          width={100}
          height={100}
          style={{ borderRadius: "50%", objectFit: "cover" }}
        />
        <Column alignItems={AlignItems.Start} gap={10}>
          <Heading size={24} color={theme.textOnBg}>
            {fullname}
          </Heading>
          <Text size={16} color={theme.icon}>
            {role}
          </Text>
        </Column>
        <IconAnimation
          Icon={InfoIcon}
          onHoverColor={theme.secondary}
          className="cursor-pointer"
          width={24}
          height={24}
          onClick={onShowInfo}
        />
      </Row>
      <AccessList
        style={{ width: "calc(100% - 4rem)", margin: "1rem 2rem" }}
        accessList={access_list}
        readOnly
      />
      <Row
        style={{ width: "calc(100% - 4rem)", margin: "1rem 2rem" }}
        justifyContent={JustifyContent.Center}
        gap={20}
      >
        {user?.access_list.includes("Admin") ||
        user?.username === props.username ? (
          <>
            <Button
              onClick={onEditUser}
              background={theme.secondary}
              color={theme.textonSecondary}
            >
              ویرایش
            </Button>
            {user.username !== props.username ? (
              <Button
                onClick={onDelete}
                background={theme.alert}
                color={theme.textOnAlert}
              >
                حذف
              </Button>
            ) : (
              <></>
            )}
          </>
        ) : (
          <></>
        )}
      </Row>
    </Column>
  );
};

export default UserProfilePopup;
